export default "__VITE_PUBLIC_ASSET__6a66b4f1__"